import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IConversionApiDependencySegment } from '@cbridge-packages/api-conversion';
import { catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolPriceAction } from '../symbolPrice.action';
import { SymbolPriceTranslator } from '../symbolPrice.translator';

type IDependencies = IConversionApiDependencySegment;

export const loadSymbolPriceListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolPriceAction.loadList.started),
  mergeMap((params) => {
    return dependencies.csApi.getPrices({}).pipe(
      mergeMap((response) => {
        const { prices } = response;

        const items = prices.map(SymbolPriceTranslator.fromApi);

        return [SymbolPriceAction.loadList.done({ params, result: { items } })];
      }),
      catchApiError((error) => {
        return [SymbolPriceAction.loadList.failed({ params, error }), createApiErrorNotification(error)];
      }),
    );
  }),
);
